import axios, { AxiosInstance } from "axios";

export function createProductServiceAxiosClient(): AxiosInstance {
  return axios.create({
    baseURL: import.meta.env.VITE_PRODUCT_SERVICE_BASE_URL,
  });
}
